import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import { grayColor } from "../../../../../assets/jss/material-dashboard-pro-react";

const nodeVisibilityControlsStyle = (clientColor) => ({
  nodeControls: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "8px 12px",
    backgroundColor: grayColor[13],
    borderRadius: "4px",
    marginBottom: "8px",
    fontSize: "11px",
    flexShrink: 0,
  },
  nodeCheckbox: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
    "& input[type='checkbox']": {
      margin: 0,
      accentColor: clientColor,
      cursor: "pointer",
      "&:disabled": {
        cursor: "not-allowed",
        opacity: 0.6,
      },
    },
    "& label": {
      fontSize: "11px",
      cursor: "pointer",
      margin: 0,
      "&.disabled": {
        color: grayColor[6],
        cursor: "not-allowed",
      },
    },
  },
  controlsLabel: {
    fontWeight: "bold",
    color: grayColor[1],
    marginRight: "8px",
  },
});

const NodeVisibilityControls = ({
  visibleNodes,
  onNodeVisibilityChange,
  nodeStructure,
  clientColor,
}) => {
  const useStyles = makeStyles(() => nodeVisibilityControlsStyle(clientColor));
  const classes = useStyles();

  // Handle checkbox change
  const handleCheckboxChange = (nodeKey) => (event) => {
    onNodeVisibilityChange(nodeKey, event.target.checked);
  };

  // Only render if we have valid metadata from backend
  if (
    !nodeStructure ||
    typeof nodeStructure !== "object" ||
    Object.keys(nodeStructure).length === 0
  ) {
    return (
      <div className={classes.nodeControls}>
        <span className={classes.controlsLabel}>Show nodes:</span>
      </div>
    );
  }

  const nodeKeys = Object.keys(nodeStructure);

  return (
    <div className={classes.nodeControls}>
      <span className={classes.controlsLabel}>Show nodes:</span>
      {nodeKeys.map((nodeKey) => {
        const node = nodeStructure[nodeKey];
        // Use simplified metadata structure: node.name (string)
        const nodeName = node?.name || nodeKey;

        return (
          <div key={nodeKey} className={classes.nodeCheckbox}>
            <input
              type="checkbox"
              id={`node-${nodeKey}`}
              checked={visibleNodes[nodeKey] || false}
              onChange={handleCheckboxChange(nodeKey)}
            />
            <label htmlFor={`node-${nodeKey}`}>{nodeName}</label>
          </div>
        );
      })}
    </div>
  );
};

NodeVisibilityControls.propTypes = {
  visibleNodes: PropTypes.object.isRequired,
  onNodeVisibilityChange: PropTypes.func.isRequired,
  nodeStructure: PropTypes.object.isRequired,
  clientColor: PropTypes.string,
};

export default NodeVisibilityControls;
